import marcadorConsumoAlimentar from "./marcadorConsumoAlimentarRepository"
import parametrizacaoRepository from "./parametrizacaoRepository"
import fichaComplementarRepository from "./fichaComplementarRepository"
import cadastroIndividualRepository from "./cadastroIndividualRepository"
import cadastroDomiciliarRepository from "./cadastroDomiciliarRepository"
import relatorioAtendimentoOdontologico from "./relatorioAtendimentoOdontologico"
import atendimentoIndividualRepository from "./atendimentoIndividualRepository"
import atendimentoOdontologicoRepository from "./atendimentoOdontologicoRepository"
import atividadeColetivaRepository from "./atividadeColetivaRepository"
import relatorioCadastroConsistenteRepository from "./relatorioCadastroConsistenteRepository"
import avaliacaoRepository from "./avaliacao"
import procedimentoRepository from "./procedimentoRepository"
import exportacaoRepository from "./exportacaoRepository"
import fichaVacinacaoRepository from "./fichaVacinacaoRepository"
import visitaDomiciliarRepository from "./visitaDomiciliarRepository"
import atendimentoDomiciliarRepository from "./atendimentoDomiciliarRepository"
import relatorioEstatisticoAtendimento from "./relatorioEstatisticoAtendimentoRepository"
import relatorioInconsistenciaRepository from "./relatorioInconsistenciaRepository"

export default baseUrl => {
    baseUrl = `${baseUrl}/atencao-basica`

    return {
        marcadorConsumoAlimentar: marcadorConsumoAlimentar(baseUrl),
        parametrizacao: parametrizacaoRepository(baseUrl),
        fichaComplementar: fichaComplementarRepository(baseUrl),
        cadastroIndividual: cadastroIndividualRepository(baseUrl),
        cadastroDomiciliar: cadastroDomiciliarRepository(baseUrl),
        relatorioAtendimentoOdontologico: relatorioAtendimentoOdontologico(baseUrl),
        atendimentoIndividual: atendimentoIndividualRepository(baseUrl),
        atendimentoOdontologico: atendimentoOdontologicoRepository(baseUrl),
        atividadeColetiva: atividadeColetivaRepository(baseUrl),
        relatorioCadastroConsistente: relatorioCadastroConsistenteRepository(baseUrl),
        avaliacao: avaliacaoRepository(baseUrl),
        procedimento: procedimentoRepository(baseUrl),
        exportacao: exportacaoRepository(baseUrl),
        fichaVacinacao: fichaVacinacaoRepository(baseUrl),
        visitaDomiciliar: visitaDomiciliarRepository(baseUrl),
        atendimentoDomiciliar: atendimentoDomiciliarRepository(baseUrl),
        relatorioEstatisticoAtendimento: relatorioEstatisticoAtendimento(baseUrl),
        relatorioInconsistencia: relatorioInconsistenciaRepository(baseUrl),
    }
}
